import { render, staticRenderFns } from "./ExaminationManagement.vue?vue&type=template&id=cfcbd67e&scoped=true"
import script from "./ExaminationManagement.vue?vue&type=script&lang=js"
export * from "./ExaminationManagement.vue?vue&type=script&lang=js"
import style0 from "./ExaminationManagement.vue?vue&type=style&index=0&id=cfcbd67e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcbd67e",
  null
  
)

export default component.exports